<template>
    <div>Version {{applicationVersion}}</div>
</template>

<script>
import packageInfo from "../../package.json"
export default {
  data() {
    return {
      applicationVersion: packageInfo.version,
    };
  },
};
</script>

<style scoped>
div {
    padding:10px 20px;
    text-align: right;
}
</style>
